/* ============================================================
   DUST — drifting motes in the void. Purely decorative; the mote
   set is computed once from the channel count-independent layout.
   No state: the randomized layout is derived at module load so
   renders stay pure (and the lint rule stays satisfied).
   ============================================================ */
import type { CSSProperties } from 'react'
import styles from './Dust.module.css'

const MOTES = Array.from({ length: 26 }, () => {
  const size = 1 + Math.random() * 3
  return {
    width: size + 'px',
    height: size + 'px',
    left: Math.random() * 100 + '%',
    top: 60 + Math.random() * 45 + '%',
    '--mote-dx': Math.random() * 80 - 40 + 'px',
    '--mote-dy': -120 - Math.random() * 220 + 'px',
    '--mote-op': (0.18 + Math.random() * 0.4).toFixed(2),
    animationDuration: 12 + Math.random() * 18 + 's',
    animationDelay: -Math.random() * 20 + 's',
  } as CSSProperties
})

export function Dust() {
  return (
    <div className={styles.dust}>
      {MOTES.map((style, i) => (
        <div key={i} className={styles.mote} style={style} />
      ))}
    </div>
  )
}
